




import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			showParkingIframe: true,
		};
	},
	computed: {
		wmsParkingUrl() {
			return `${this.dmsSys.DMSC_url}/wms/WmsParking`;
		},
	},
});
